module.exports = __webpack_public_path__ + "static/media/Illus-PlateEmpty.ef02b7dd.png";